import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';

class PopupVerify extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shippingNo:"",
            forgotemail: "",
            activeView: 'confirmView',
            tableVisible: false,
            valid: false,
            orderNr: '',
            comment: ''
        };

        this.nextView = this.nextView.bind(this)
        this.toggleTableVisibility = this.toggleTableVisibility.bind(this)
        this.handleOutsideClick = this.handleOutsideClick.bind(this)
    }

    toggleValid() {
        this.setState({
            valid: !this.state.valid
        })
    }

    countPallets(orders) {
        return Math.ceil(orders.length / 3)
    }

    countWeight(orders) {
        return orders.length * 80;
    }

    toggleTableVisibility(e) {
        e.preventDefault();
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }

    nextView() {
        if (this.state.activeView === 'confirmView')
            this.setState({activeView: 'verifyView'})
    }

    handleSubmit = (event) => {
        event.preventDefault();
    }

    handleOutsideClick(e) {
        if (e.target === e.currentTarget && !this.props.sending) {
            this.props.closePopup()
        }
    }


    onChange(e){
        this.setState({shippingNo:e.target.value});
        if (typeof(this.props.onChange)==="function"){
            this.props.onChange(e)
        }
    }

    render() {
        const confirmView = (
            <div>
                <span className='cursive'>Skickas från</span>
                <h1>{this.props.wheelInfo.fromStationName}</h1>
                <div>
                    <span className='bold'>Order id: </span>{this.props.wheelInfo.id}
                </div>
                <div>
                    <span className='bold'>Stationsnummer: </span>{this.props.wheelInfo.retailerId}
                </div>
                <div>
                    <span className='bold'>Adress: </span>{this.props.wheelInfo.fromAddress}
                </div>
                <div>
                    <span className='bold'>Postadress: </span>
                    {this.props.wheelInfo.fromPostalCode} {this.props.wheelInfo.fromCity}
                </div>

                <hr/>

                <span className='cursive'>Kontaktperson</span>
                <h1 className='green'>{this.props.wheelInfo.contact}</h1>
                <div>
                    <span className='bold'>Mobil: </span>{this.props.wheelInfo.contactPhone}
                </div>

                <button onClick={this.nextView} className='next'>Vidare</button>
            </div>
        )

        const verifyView = (
            <div>
                <button className='close' onClick={this.props.closePopup}></button>

                <h1>Verifiera</h1>

                <div className='table to-shift orders-to-verify'>
                    <ReactTable
                        data={this.props.data}
                        columns={[
                            {
                                Header: "Regnr",
                                accessor: "regNo",
                                width:90
                            },
                            {
                                Header: "Bilmodell",
                                accessor: "carModel",
                                width:220
                            },
                            {
                                Header: "Hjulmodell",
                                accessor: "wheeltype",
                                width:100
                            },
                            {
                                Header: "Last on rent",
                                accessor: "lastOnRentDate",
                            }
                        ]}
                        defaultPageSize={this.props.data.length}
                        className={this.props.data.length < 5 || this.state.tableVisible ? 'visible' : 'hidden'}
                        showPagination={false}
                        noDataText='Inga däck tillagda i ordern'
                    />
                    {
                        this.props.data.length >= 5 ?
                            <button
                                onClick={this.toggleTableVisibility.bind(this)}>
                                {this.state.tableVisible ? 'Dölj' : 'Visa alla'} ({this.props.data.length})
                            </button> : null
                    }
                </div>

                <h1>
                    Ordernummer {this.props.wheelInfo.id} - {this.props.wheelInfo.pallets} {this.props.wheelInfo.pallets === 1 ? 'pall' : 'pallar'} - {this.props.wheelInfo.weight}kg
                </h1>

                <hr/>

                <div className='row'>
                    <div className='col-left'>
                        <div>
                            <span className='bold'>{this.props.wheelInfo.fromStationName}</span>
                        </div>
                        <div>
                            <span className='bold'>Upphämtningsadress: </span>{this.props.wheelInfo.fromAddress}
                        </div>
                        <div>
                            <span className='bold'>Postadress: </span>
                            {this.props.wheelInfo.fromPostalCode} {this.props.wheelInfo.fromCity}
                        </div>
                    </div>
                    <div className='arrow'>
                        <span></span>
                    </div>
                    <div className='col-right'>
                        <div>
                            <span className='bold'>{this.props.wheelInfo.toStationName}</span>
                        </div>
                        <div>
                            <span className='bold'>Leveransadress: </span>{this.props.wheelInfo.toAddress}
                        </div>
                        <div>
                            <span className='bold'>Postadress: </span>
                            {this.props.wheelInfo.toPostalCode} {this.props.wheelInfo.toCity}
                        </div>
                    </div>
                </div>

                <hr/>

                <div className='comment'>
                    <span className='bold'>Ev kommentar: </span>
                    <input
                        type='text'
                        maxLength='250'
                        placeholder='Ev kommentar (max 250 tecken)'
                        onChange={this.props.onChange.bind(this)}
                        // value={this.props.comment}
                        name='comment'
                    />
                </div>

                <hr/>

                <div className='confirm'>
                    <span className='bold'>Skriv sändningsnummer för verifikation:</span>
                    <input
                        ref={"shippingNo"}
                        type='text'
                        placeholder='Sändningsnummer'
                        name='shippingNo'
                        onChange={(e)=>this.onChange(e)}
                    />
                    <button
                        onClick={this.props.submit.bind(this)}
                        name='confirm-order-send-to'
                        disabled={this.state.shippingNo.length===0}>
                        Bekräfta
                    </button>
                </div>
            </div>
        )

        return (
            <div
                className='popup verify'
                name='popupOverlay'
                onClick={this.handleOutsideClick}
            >
                <div className='popup_inner verify'>
                    <button className='close' onClick={this.props.closePopup}></button>

                    {this.state.activeView === 'confirmView' ? confirmView : verifyView}

                </div>
            </div>
        );
    }
}

export default PopupVerify


// WEBPACK FOOTER //
// ./src/components/Stock/PopupVerify.js